<template>
    <div class="interface-help">
        <h2>Отправка электронной почты</h2>
        <p>
            Данный интерфейс, имитирует работу с приложением отправки электронной почты.
        </p>
        <p>
            В нем есть поле для ввода текста, который в дальнейшем будет отправлен<br>
            <img class="interface-help__image interface-help__image--1" src="/images/help/mail-send-textarea.jpg" alt="">
        </p>
        <p>
            Для отправки письма, нужно нажать кнопку "Отправить"<br>
            <img class="interface-help__image interface-help__image--2" src="/images/help/mail-send-button.jpg" alt="">
        </p>
        <p>
            Письмо считается отправленным, после появления соответствующего сообщения<br>
            <img class="interface-help__image interface-help__image--3" src="/images/help/mail-send-popup.png" alt="">
        </p>
        <p>
            Общий вид отправки электронной почты<br>
            <img class="interface-help__image" src="/images/help/mail-send.jpg" alt="">
        </p>
    </div>
</template>
<script>
    export default {}
</script>
<style lang="stylus" scoped>
    .interface-help {
        p {
            max-width 80%
        }

        &__image {
            max-width 60%
            border 1px solid rgba(0, 0, 0, .4)

            &--1 {
                max-width 80%
            }

            &--2 {
                max-width 113px
            }

            &--3 {
                max-width 500px
            }
        }
    }
</style>